import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.poll', ['whyline.resources.resource']);

const PollFactory = ($timeout, $http, API_URL, Resource) => {
  /* @ngInject */
  // API REST Resource Name
  const _type = 'poll';
  const apiEndPoint = `${API_URL}${_type}`;

  const _schema = {};

  const Poll = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.setEnable = (enabled) => {
      const promise = $http.put(`${API_URL}${_type}/${this._id}/enabled`, {
        enabled,
      });

      promise.then((response) => {
        const item = response.data;

        $timeout(() => {
          // Cuando halla respuesta, modificar el cache
          Plan.UpdateCache(item._id, item, null);
        });

        // Devuelve la respuesta desde el cache.
        return Plan.GetOneFromCache('_id', this._id);
      });
      return promise;
    };
  };

  Poll.prototype = new Resource(_type, _schema, Poll);

  Resource.Extend(_type, Poll);

  Poll.GetAnswers = ({ organizationId, from, to }) => {
    const url = `${API_URL}${_type}/answers`;
    return $http
      .get(url, { params: { organizationId, from, to } })
      .then((response) => response.data);
  };

  Poll.GetAnswersExport = ({ organizationId, from, to }) => {
    const url = `${API_URL}${_type}/answers/export`;
    return $http.get(url, { params: { organizationId, from, to } });
  };

  // one hour
  const validityTime = 60 * 60 * 5000;
  Poll.InitCache(validityTime);

  return Poll;
};

module.exports = module.factory('Poll', PollFactory);
